import $ = require('jquery');
import Modul, {OpenConfig} from './Modul';
import l10n = require('diy/util/l10n');

/**
 * Guestbook module class
 *
 */
export default class ModulGuestbook extends Modul {
    loadIcon = '<img src="' + cc_.cdnServer + 's/img/cms/loading/timeline.gif" alt="" /><br />';
    private confirmDialog: JQuery;
    private commentIdToDelete: string;

    constructor(moduleId: number) {
        super(moduleId);
        let self = this;

        self.getModuleForm().diy_form();

        $('.guestbook .form-item input[type="radio"]', self.getModuleForm()).diy_radiobox();

        $('input[name=receiveMail]', self.getModuleForm()).diy_radiobox().change(function(e) {
            /* tslint:disable:triple-equals */
            self.toggleReceiverEmailAddress($(this).val() == 1);
            /* tslint:enable:triple-equals */
            self.validate();
        });

        self.getReceiverEmailAddress().keyup(function() {
            self.validate();
        });

        self.loadButtons();
        self.setSaveAction(self.validateAndSave);
        self.validate();
    }

    getModuleForm() {
        return $('#formular_' + this.moduleId);
    }

    getReceiverEmailAddress() {
        return $('#receiverEmailAddress_' + this.moduleId);
    }

    open(openConfig?: OpenConfig) {
        // do also parent function //
        super.open(openConfig);

        // if invalid focus the invalid field //
        if (!this.isValid()) {
            this.getReceiverEmailAddress().get(0).focus();
        }
    }

    validateAndSave() {
        //no validation blocking anymore if(this.isValid()) ...
        this.save();
    }

    //sometimes receiverEmailAddress is "disabled" and would not be inside the sent data, so we add it manually
    getSaveData() {
        let data = super.getSaveData();
        data.push({
            name: this.getReceiverEmailAddress().attr('name'),
            value: this.getReceiverEmailAddress().val()
        });
        return data;
    }

    loadButtons() {
        $('.com-edit a').button();
    }

    confirmDelete(commentId: string) {
        let triggerBtn = $('#com-delete-btn-' + this.moduleId + '-' + commentId);
        let content = '#com-confirm-delete-' + this.moduleId;
        let self = this;
        let $window = $(window);
        let msg = l10n.getMessages('guestbook.deletedialog');
        this.confirmDialog = $(content).diy_confirmationDialog({
            buttons: [{
                text: msg['delete'] as string,
                click: function() { self.deleteComment(commentId); }
            }, {
                text: msg['cancel'] as string,
                click: function() { self.abortDelete(); },
                "class": "button-cancel"
            }],

            modal: true,
            position: [triggerBtn.offset().left - $window.scrollLeft(), triggerBtn.offset().top - $window.scrollTop()]
        });
        this.commentIdToDelete = commentId;
    }

    abortDelete() {
        this.commentIdToDelete = null;
        this.closeDialog();
    }

    closeDialog() {
        this.confirmDialog.diy_confirmationDialog('close');
    }

    deleteComment(commentId: string) {
        let self = this;
        commentId = commentId || this.commentIdToDelete;
        $('#commentEntry' + commentId).html(this.loadIcon);
        let moduleId = this.moduleId;
        $.ajax({
            url: '/app/module/guestbook/delete',
            type: 'POST',
            data: {
                moduleId: moduleId,
                commentId: commentId
            },
            success: function(r) {
                if (r) {
                    $('#guestbook-' + moduleId).replaceWith(r);
                    self.loadButtons();
                }
            }
        });
        this.commentIdToDelete = null;
        this.closeDialog();
    }

    toggleCommentStatus(commentId: string) {
        let self = this;
        $('#commentEntry' + commentId).html(this.loadIcon);
        let moduleId = this.moduleId;
        $.ajax({
            url: '/app/module/guestbook/toggle',
            type: 'POST',
            data: {
                moduleId: moduleId,
                commentId: commentId
            },
            success: function(r) {
                if (r) {
                    $('#guestbook-' + moduleId).replaceWith(r);
                    self.loadButtons();
                }
            }
        });
    }

    toggleReceiverEmailAddress(checked: boolean) {
        if (!checked) {
            this.getReceiverEmailAddress().prop('disabled', true);
        } else {
            this.getReceiverEmailAddress().prop('disabled', false);
        }
    }

    validate() {
        this.clearErrors();
        if ($('input[name=receiveMail]', this.getModuleForm()).diy_radiobox('option', 'checked')) {
            let receiverEmailAddressElement = this.getReceiverEmailAddress();
            if (!diy.util.validator.isEmail(receiverEmailAddressElement.val())) {
                let errorMsg = $(
                    '#receiverEmailAddress_error_message_' + this.moduleId,
                    $('#formular_' + this.moduleId)
                ).text();
                errorMsg = '<div>' + errorMsg + '</div>';
                this.showInputError(receiverEmailAddressElement,  errorMsg);
            }
        }
    }

    isValid() {
        this.validate();
        if (this.getModuleForm().diy_form('hasError')) {
            return false;
        }
        return true;
    }

    clearErrors() {
        this.getModuleForm().diy_form('clearErrors');
    }

    showInputError(element: JQuery, errorMsg: string) {
        element.diy_textField({
            tooltipOptions: {
                anchor: 'left'
            }
        });
        element.diy_textField('addError', errorMsg);
        element.diy_textField('showError');
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulGuestbook.ts
 **/